import { AllRepresentativeUrlsQuery, RepresentativeDetailQuery } from 'queries/representatives'
import Spacer from 'basics/Spacer'
import Footer from 'features/Footer'
import Masthead from 'features/Masthead'
import PageLayout from 'layouts/PageLayout'
import { GQLClient } from 'services/graphql'
import { Flatten, PickFirst } from 'services/utils'
import { GetCachedData, GetMetaData, FetchAllData } from 'services/data.service'
import PersonDetail from 'features/PersonDetail'
import CtaBanner from 'features/CtaBanner'
import Container from 'containers/Container'
import SupportingContent from 'layouts/SupportingContent'
import TextBlock from 'layouts/TextBlock'
import InlineEventList from 'features/InlineEventList'
import Resources from 'features/Resources'
import { HandleResources } from 'services/resources.service'
import Tags from 'components/Tags'
import SupportingContentBlocks from 'features/SupportingContentBlocks'
import { useRouter } from 'next/router'

const RepresentativeDetail = ({
  pageData,
  topNav,
  mainNav,
  meta,
  footerContent,
  applicationSettings = {}
}) => {
  const router = useRouter()
  if (router.isFallback) {
    return <>Page regenerating,reload in a second</>
  }
  const {
    firstName,
    fullBio,
    associatedEvents = [],
    resources = [],
    categoryOrType = [],
    supportingContent = []
  } = pageData || {}
  const ctaFeature = PickFirst(pageData.ctaFeature)
  return (
    <PageLayout meta={meta} applicationSettings={applicationSettings}>
      <Masthead
        topLinks={topNav?.links || []}
        mainLinks={mainNav?.links || []}
        route={{ slug: ['representatives'] }}
      />

      <Container className="mb-20 md-mb-13" zIndex="5">
        <PersonDetail {...pageData} />
      </Container>

      <Spacer size={20} mdSize={13} />

      <SupportingContent
        type={associatedEvents?.length > 0 ? `twothirds` : 'full'}
        gridGap={77}
        containerOptions={{ narrow: true }}
      >
        <TextBlock align="flex-start">
          <h2 className="mb-4">About {firstName}</h2>
          <div className="mb-3" dangerouslySetInnerHTML={{ __html: fullBio }} />
          {categoryOrType && categoryOrType?.length > 0 && (
            <Tags tags={categoryOrType} className="mb-4" />
          )}
        </TextBlock>

        {associatedEvents && associatedEvents?.length > 0 && (
          <InlineEventList events={associatedEvents} />
        )}
      </SupportingContent>

      <Spacer size={20} mdSize={13} />

      <SupportingContentBlocks blocks={supportingContent} />

      <Resources
        className="mb-20 md-mb-13"
        headline="Recommended Resources"
        subheadline="Explore blogs, articles, and news from First Business Bank's team of experts. Make business decisions based on the latest data and insights."
        resources={resources}
        linkText="Visit our Resource Center"
        targetPage="/resource-center"
      />

      {ctaFeature && (
        <Container narrow={true} className="mb-20 md-mb-13">
          <CtaBanner data={ctaFeature} />
        </Container>
      )}

      <Footer
        navLinks={topNav?.links || []}
        footerLinks={mainNav?.links || []}
        footerContent={footerContent}
      />
    </PageLayout>
  )
}
export default RepresentativeDetail

export async function getStaticProps(context) {
  const id = context.params.id
  const searchSlug = (id && id?.includes('representatives')) ? id : `representatives/${id}`
  const client = await GQLClient()
  const data = await client.request(RepresentativeDetailQuery(searchSlug))
  const pageBase = Flatten(PickFirst(data.queryBasePageContents))
  const content = Flatten(PickFirst(pageBase.referencingPersonContents))
  let pageData = {
    type: '',
    pageData: content,
    meta: GetMetaData(pageBase)
  }
  pageData = GetCachedData(pageData)
  let force = true
  if (content?.referencingResourceContents?.length < 1) {
    pageData.pageData.resources = { resource: content?.referencingPersonContents?.flatData?.resourcesWithHeadline }
  } else {
    force = false
    pageData.pageData.resources = { resource: content?.referencingResourceContents }
  }

  pageData.pageData = await HandleResources({ pageData: pageData.pageData, force })

  const config = {
    props: pageData || {}
  }

  if (process.env.IS_PREVIEW) {
    config.revalidate = 2
  }

  return config
}

export async function getStaticPaths() {
  const data = await FetchAllData(AllRepresentativeUrlsQuery, 'queryPersonContentsWithTotal') //await client.request(AllRepresentativeUrlsQuery, {}).catch((err) => console.log(err))

  const basePages = data
  const paths = basePages
    .filter((page) => {
      page = Flatten(page)
      const base = PickFirst(page.pageBase)
      if (base && base?.url && base?.url?.includes('?')) {
        return false
      }
      return base && base?.url ? true : false
    })
    .map((page) => {
      page = Flatten(page)
      const base = PickFirst(page.pageBase) || {}

      return {
        params: { id: base?.url?.split('/')?.pop() }
      }
    })
  return {
    paths,
    fallback: false
    // fallback: process.env.IS_PREVIEW ? 'blocking' : false
  }
}
